export default "__VITE_ASSET__Di4ctwbk__"